import { gql } from "@apollo/client";

export const GET_DEDUCTION_TYPES_LOOKUP = gql`
  query DeductionTypesLookup {
    deductionTypesLookup {
      count
      items {
        id
        parentId
        deductionName
        deductionTypeKey
        subtypes {
          id
          parentId
          deductionName
          deductionTypeKey
        }
      }
    }
  }
`;
